import { LOGOUT, AUTH_SUCCESS, SYNC_USER, ADD_ADDRESS, REMOVE_ADDRESS, CART_LOADING, ADD_TO_CART, REMOVE_FROM_CART } from '../actions/type'

import { v4 as uuidv4 } from 'uuid'

const initialState = {
    isAuthenticated: null,
    uid: null,
    profile: {},
    cart: {},
    cartChangeToken: null,
    cartLoading: false
};

// profile --> name, email, photoUrl,favorite, addresses

export default (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                uid: action.payload
            }
        case SYNC_USER:
            return {
                ...state,
                profile: { ...action.payload.profile },
                cart: action.payload.cart
            }
        case CART_LOADING:
            return {
                ...state,
                cartLoading: true
            }
        case ADD_TO_CART:
        case REMOVE_FROM_CART:
            return {
                ...state,
                cartChangeToken: uuidv4(),
                cartLoading: false,
                cart: action.payload
            }
        case LOGOUT:
            return {
                ...initialState,
                isAuthenticated: false
            }

        default:
            return state
    }
}


